import { flickity } from '../util/flickity';
import AjaxLoader from '../util/ajax_util';
import { initContainers, teardownContainers } from '../util/init';
import { lazyloadUnset, lazyloadSet } from '../util/miscellaneous';

export default function handleAjaxPageLoad (ajaxTrigger, transtisionType) {
  const url = ajaxTrigger.getAttribute('href') || ajaxTrigger.dataset.href;
  const ajax = new AjaxLoader(
    'artisan',
    function ($newBody) {
      window.setTimeout(() => {
        const newBody = $newBody[0];
        const newArticle = newBody.querySelector('#content > article');
        lazyloadSet(newArticle);
        const currentArticle = document.querySelector('#content > article');
        let newContent;
        let currentContent;

        let scrollTo;
        if (
          currentArticle.getAttribute('data-collection-scroll') &&
          !ajaxTrigger.classList.contains('filters-filter') &&
          !newArticle.querySelector('.collection') &&
          !newArticle.classList.contains('collection-product')
        ) {
          scrollTo = currentArticle.getAttribute('data-collection-scroll');
        } else {
          scrollTo = document.querySelector('.site-header').offsetHeight;
        }
        window.scroll({
          top: scrollTo,
          left: 0,
          behavior: 'smooth'
        });
        teardownContainers(document.querySelectorAll('#content > article'));
        currentArticle.classList.remove(currentArticle.classList)
        
        const newClasses = [...newArticle.classList];
        newClasses.forEach((newClass) => {
          currentArticle.classList.add(newClass);
        });

        switch (transtisionType) {
          case 'collection-product':
            // currently used for all collectionand product links,
            newContent = newBody.querySelector('.ajax-content');
            currentContent = document.querySelector('.ajax-content');
            currentContent.innerHTML = newContent.innerHTML;
            break;

          default:
            console.log('no transtisionType set');
        }
        // init pages
        initContainers(document.querySelectorAll('#content > article'));
        const loading = document.querySelectorAll('.loading-spinner');
        loading.forEach(x => {
          x.classList.add('disabled');
        });
        document.body.classList.remove('reset-scroll');
        lazyloadUnset(currentContent);
      }, 200);
    },
    {
      onBeforeLoad: function (url) {
        // const currentUrl = window.location.pathname + window.location.search + window.location.hash;
        // window.history.replaceState({ns: 'artisan'}, null, currentUrl);
        document.body.classList.add('reset-scroll');
        const currentArticle = document.querySelector('#content > article');
        if (currentArticle.classList.contains('collection-collection') ||
              currentArticle.classList.contains('collection-product')) {
          // store the current scroll position
          let collectionScroll = Math.max(
            document.documentElement.scrollTop,
            document.body.scrollTop
          );
          currentArticle.setAttribute(
            'data-collection-scroll',
            collectionScroll
          );
        }
      }
    }
  );
  ajax.load(url, null);
}



// WEBPACK FOOTER //
// ./assets/j/src/ajax-page.js